import { useState } from "react"
import { ChevronDown, ChevronUp } from "lucide-react"
import { useTranslation } from 'react-i18next'

interface FAQItem {
  question: string
  answer: string
}

export default function FAQSection() {
  const { t } = useTranslation()
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const items = t('landing.faq.items', { returnObjects: true }) as FAQItem[]

  return (
    <section id="faq" className="py-20 bg-green-50 dark:bg-gray-950">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p
            className="text-sm font-medium text-gray-500 dark:text-gray-300 mb-2"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            {t('landing.faq.sectionLabel')}
          </p>
          <h2
            className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            {t('landing.faq.headline')}
          </h2>
        </div>

        <div className="space-y-3">
          {items.map((item, i) => (
            <div
              key={i}
              className="bg-white dark:bg-gray-900 rounded-xl border border-gray-100 dark:border-gray-700 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                aria-expanded={openIndex === i}
              >
                <span
                  className="text-sm font-semibold text-gray-900 dark:text-white pr-4"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  {item.question}
                </span>
                {openIndex === i ? (
                  <ChevronUp size={18} className="text-green-500 flex-shrink-0" />
                ) : (
                  <ChevronDown size={18} className="text-gray-400 dark:text-gray-200 flex-shrink-0" />
                )}
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p
                    className="text-sm text-gray-600 dark:text-gray-200 leading-relaxed"
                    style={{ fontFamily: "'DM Sans', sans-serif" }}
                  >
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
